import { render, staticRenderFns } from "./OuterLinks.vue?vue&type=template&id=2a891d7e&scoped=true"
import script from "./OuterLinks.vue?vue&type=script&lang=js"
export * from "./OuterLinks.vue?vue&type=script&lang=js"
import style0 from "./OuterLinks.vue?vue&type=style&index=0&id=2a891d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a891d7e",
  null
  
)

export default component.exports